namespace advisorop.components.advisor {

    export class RmdTrackerAdvisorController {

        constructor() { }

    }

    class RmdTrackerAdvisor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {};
            this.controller = ["advisorService", RmdTrackerAdvisorController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/rmd-tracker-advisor.html";
        }
    }
    angular.module(Constants.APP).component("rmdTrackerAdvisor", new RmdTrackerAdvisor());
}